<template>
<div class="chapter">
<div class="inner_page">
<p class="p5"> </p>
<p class="p1">This book is dedicated</p>
<p class="p1">to all who disapprove of blacklisting.</p>
<p class="p5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?69c206b4